import { CustomError } from 'ts-custom-error';

import { setClassName } from '@change-corgi/core/error';

export class ClientPrefetchError extends CustomError {}
setClassName(ClientPrefetchError, 'ClientPrefetchError');
